// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 563) return "7.0.35156-app-client-developer-side-nav.min.js";
	// return url for filenames based on template
	return undefined;
};